'use client';

import Link from 'next/link';
import { slugify } from '../utils/helper/slugify';

interface Category {
  _id?: string;
  title: string;
  slug?: { current?: string };
}

export default function CategoryLinks({
  categories,
}: {
  categories: Category[];
}) {
  return (
    <div className="flex flex-wrap items-center gap-1">
      {categories.map((category, ind) => {
        const categorySlug = category.slug?.current || slugify(category.title);

        return (
          <Link
            key={category._id || ind}
            href={`/blog/category/${categorySlug}`}
            onClick={(e) => e.stopPropagation()}
            className="text-sm font-medium leading-normal text-lightBlue transition-all hover:underline md:text-base"
          >
            {category.title}
            {ind < categories.length - 1 && ' , '}
          </Link>
        );
      })}
    </div>
  );
}
